// The OLD way in to /api: a shared x-api-key header. It authenticates as a
// machine, so once Google sign-in is on the browser must not send it at all —
// src/index.js clears it and the session cookie takes over.
//
// The key is never stored in this repo: the dashboard asks for it once and
// remembers it in the browser (localStorage).
const STORAGE_KEY = 'pm_api_key';

// Asks the user if there is no key yet. Only for the pre-sign-in fallback.
export function getApiKey() {
  let key = localStorage.getItem(STORAGE_KEY);
  if (!key) {
    key = window.prompt('Enter the dashboard access key:');
    if (key) localStorage.setItem(STORAGE_KEY, key.trim());
  }
  return key ? key.trim() : '';
}

// Never prompts. Use this anywhere a prompt would be wrong — with sign-in on
// there is no key to give, and asking for one is just a dead end.
export function storedApiKey() {
  return (localStorage.getItem(STORAGE_KEY) || '').trim();
}

export function clearApiKey() {
  localStorage.removeItem(STORAGE_KEY);
}
